import React from "react"
import Lottie from "react-lottie"
import data from "../../animation-data/confetti.json"

export default ({}) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,

    animationData: data,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }

  return (
    <span title="Confetti" className="brand-confetti">
      <Lottie
        isClickToPauseDisabled={true}
        options={defaultOptions}
        width={"100%"}
      />
    </span>
  )
}
